import styled from 'styled-components';
import { DEVICES, pickThemeFontStyles } from '@/theme';
import { Modal } from '@/components';
import { Input } from '@/ui';

export const StyledInput = styled(Input)`
  ${pickThemeFontStyles('14', '22', 'BOLD')};
  height: 2.85rem;
`;

export const StyledModal = styled(Modal)`
  ${pickThemeFontStyles('12', '18')};
  margin-bottom: 1rem;

  .ant-modal-body {
    gap: 1rem;
    flex-direction: column;
    display: flex;
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('14', '16')};
    margin-bottom: 1.5rem;
  }
`;
